export const DEFAULT_NUMBER_OF_BOOKINGS_SHOWN = 1;
